//Para elegir a que back end pegarle, si el de pruebas o el de produccion

//export const API_BASE_URL = 'https://goethehub-a4hbekbvd3byabhe.brazilsouth-01.azurewebsites.net/';
//export const API_BASE_URL = 'http://localhost:8001/';
export const API_BASE_URL = 'https://apigatewayyarp.thankfulfield-7d43091d.brazilsouth.azurecontainerapps.io/';